import { Medium } from '@energiebespaarders/symbols/helpers';
import {
  ChatAlertAlt,
  ClipboardCheck,
  FileEuro,
  Shield,
  WrenchScrewdriver,
} from '@energiebespaarders/symbols/icons/solid';
import { QuoteInfoAccordion } from '../utils';
import { debWarranty } from './constants';

export const pvSystemInfoAccordions = (
  needsPtc: boolean,
  needsPrepayment: boolean,
): QuoteInfoAccordion[] => [
  {
    key: 'feasibility',
    title: 'Technische haalbaarheid en volledigheid',
    paragraphs: [
      'Deze offerte is geldig onder voorbehoud van technische haalbaarheid en volledigheid. Dit betekent dat er een technische controle nodig is, waarna de nog mutaties kunnen plaatsvinden, afhankelijk van eventuele complicaties en/of meerwerk.',
      'De opdracht is voorgelegd aan een van onze installateurs. Die zal bepalen of er nog een technische controle nodig is voordat de installatie kan worden gepland. Bij zonnepanelen wordt bijvoorbeeld gekeken naar de dakconstructie, meterkast en mogelijkheden voor de kabeltracé.',
    ],
    icon: ClipboardCheck,
    hide: !needsPtc,
  },
  {
    key: 'warranty',
    title: 'Installatiegarantie en service',
    paragraphs: [
      'Na inbedrijfstelling is er 1 jaar installatiegarantie. Dit omvat het gratis verhelpen van storingen die niet het gevolg zijn van onjuist of onoordeelkundig gebruik, onjuist onderhoud of ander verzuim door de gebruiker. Het normale onderhoud is niet in de prijs inbegrepen.',
      debWarranty,
    ],
    icon: Shield,
  },
  {
    key: 'invoicing',
    title: 'Facturatie',
    paragraphs: [
      ...(needsPrepayment
        ? [
            <p key="pv-invoicing-0">
              <Medium>Aanbetaling:</Medium> 25% van het totale offertebedrag wordt na het accepteren
              van de definitieve offerte {needsPtc ? '(dus na de technische controle) ' : ''}in
              rekening gebracht.
            </p>,
            <p key="pv-invoicing-1">
              <Medium>Facturatie:</Medium> 75% van het totale offertebedrag na oplevering.
            </p>,
          ]
        : [
            <p key="pv-invoicing-1">
              <Medium>Facturatie:</Medium> het totale offertebedrag na oplevering.
            </p>,
          ]),
      <p key="pv-invoicing-2">
        <Medium>Betalingstermijn:</Medium> binnen 7 dagen na factuurdatum.
      </p>,
      <p key="pv-invoicing-3">
        <Medium>Uitvoering:</Medium> in overleg, na ontvangst opdracht. Als u de opdracht wilt
        annuleren, zijn hier mogelijk kosten aan verbonden.
      </p>,
    ],
    icon: FileEuro,
  },
  {
    key: 'activities',
    title: 'Montage en coördinatie',
    paragraphs: [
      'Let op! Het uiteindelijke kabeltraject dat bij de installatie wordt geplaatst, kan afwijken van hetgeen met uw adviseur is besproken. Het kan voorkomen dat de schouwer of monteur ter plaatse moet vaststellen dat oorspronkelijk voorgestelde route technisch niet haalbaar is. Overlegt u daarom altijd voorafgaand aan de installatie met de monteur hoe deze te werk zal gaan.',
      'De werkzaamheden bij het installeren van een zonnestroomsysteem omvatten in hoofdzaak:',
      <ul key="pv-activities-1">
        <li>Het uitlijnen van panelen op het dak;</li>
        <li>Het bevestigen van het montagesysteem;</li>
        <li>Het monteren van de zonnepanelen op het montagesysteem;</li>
        <li>Het aarden van het montagesysteem;</li>
        <li>Het aanleggen van bekabeling;</li>
        <li>Het ophangen en aansluiten van de omvormer;</li>
        <li>Het inregelen, testen en bedrijfsvaardig opleveren van de installatie(s);</li>
        <li>Het netjes achterlaten van de werkplek;</li>
        <li>Het aansluiten van de monitoring via WiFi.</li>
      </ul>,
      <p key="pv-activities-2">
        Indien niet anders vermeld, zijn de volgende werkzaamheden{' '}
        <Medium>niet in deze offerte opgenomen</Medium>:
      </p>,
      <ul key="pv-activities-3">
        <li>Het verwijderen van (delen van) een ander zonnestroomsysteem.</li>
      </ul>,
    ],
    icon: WrenchScrewdriver,
  },
  {
    key: 'reminders',
    title: 'Let ook hierop',
    paragraphs: [
      'Er zijn een aantal aandachtspuntjes voor u als bewoner om de uitvoer zo soepel mogelijk te laten verlopen:',
      <ul key="pv-reminders-1">
        <li>De bewoner draagt zorg voor een vrije parkeerplaats bij de woning;</li>
        <li>
          De bewoner draagt zorg voor een goede bereikbaarheid van het dakoppervlak. Eventuele
          bosschages of bouwkundige belemmeringen dienen verwijderd te worden, zodat de uitvoerders
          vrije toegang hebben tot het dak.
        </li>
      </ul>,
      <p key="pv-reminders-2">
        <Medium>
          Let op! Koopt u een nieuwbouwwoning met zonnepanelen? Vraag dan even na of de installateur
          of de aannemer de zonnepanelen al heeft aangemeld.
        </Medium>
      </p>,
    ],
    icon: ChatAlertAlt,
  },
];
